import type React from 'react';
import { useApiLayers } from '@/components/pages/MapPage/hooks/useApiLayers';
import { useMapLayers } from '@/components/pages/MapPage/hooks/useMapLayers';
import type { MapLayersManagerProps } from './MapLayersManager.types';

/**
 * MapLayersManager Organism
 * Manages all map layers (vessels, incidents, ports, military)
 * Uses useMapLayers and useApiLayers hooks
 */
export const MapLayersManager: React.FC<MapLayersManagerProps> = ({
  getToken,
  polygonWkt,
  onPopupClick,
  onLayersInitialized,
}) => {
  // Use map layers hook for layer initialization (non-API layers)
  useMapLayers({
    getToken,
    onPopupClick,
    onLayersInitialized,
  });

  // Use API layers hook for incidents, ports, and military locations
  // These are fetched via React Query and rendered when polygon is selected
  useApiLayers({ getToken, polygonWkt: polygonWkt || null });

  return null; // This component only manages side effects
};
